"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function Khal(props) {
  var imgUrl = props.imgUrl;
  (0, _react.useEffect)(function () {
    (0, _utils.windowAddEventListener)(function () {
      (0, _utils.scaleAnimation)('multi-banner-animation-fake');
    }, 1);
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "multi-analyst-level-banner-logo",
    id: "multi-banner-animation-fake"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "multi-banner-img-1",
    src: "https://staticintl.cloudcachetci.com/cms/backend-cms/cujA547_left.png"
  }), /*#__PURE__*/_react["default"].createElement("img", {
    className: "multi-banner-img-2",
    src: "https://staticintl.cloudcachetci.com/cms/backend-cms/4dRm635_book.png"
  }), /*#__PURE__*/_react["default"].createElement("img", {
    className: "multi-banner-img-3",
    src: "https://staticintl.cloudcachetci.com/cms/backend-cms/V7gQ992_right.png"
  }), /*#__PURE__*/_react["default"].createElement("img", {
    className: "multi-banner-img-bg-transformation",
    src: imgUrl || 'https://staticintl.cloudcachetci.com/cms/backend-cms/Gn8t197_wecom-temp-a14ac276eed836e51e3842d560c05f20.png'
  }), /*#__PURE__*/_react["default"].createElement("img", {
    className: "multi-banner-img-bg",
    src: "https://staticintl.cloudcachetci.com/cms/backend-cms/cRni837_bg1.png"
  }));
}
var _default = exports["default"] = Khal;